import React from "react";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const CustomIconComponent: React.FC = () => (
  <div className="dropdown-icon-group">
    <ArrowDropUpIcon className="icon-style" />
    <ArrowDropDownIcon className="icon-style" />
  </div>
);

export default CustomIconComponent;